import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const EVENT_CUSTOM_SURVEY_RESPONSES_FILTER_QUERY_KEY = 'survey/custom/response/filter';

export function useCustomSurveyResponses({
	enabled,
	filterRequest,
	impersonationContext,
	pageSize = 25,
	refetchOnWindowFocus,
}: {
	enabled?: boolean;
	filterRequest: Api.ICustomSurveyResponseFilterRequest;
	impersonationContext?: Api.IImpersonationContext;
	pageSize?: number;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery<Api.IPagedCollection<Api.ICustomSurveyResponse>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: async ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ICustomSurveyResponse>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: `survey/custom/response/filter`,
				}),
				'POST',
				filterRequest
			);
		},
		queryKey: [EVENT_CUSTOM_SURVEY_RESPONSES_FILTER_QUERY_KEY, filterRequest, pageSize, impersonationContext],
		refetchOnWindowFocus,
		initialPageParam: '',
	});
}

export const invalidateCustomSurveyResponsesFilter = () => {
	reactQueryClient.invalidateQueries({ queryKey: [EVENT_CUSTOM_SURVEY_RESPONSES_FILTER_QUERY_KEY] });
};
